import Repository from '../Repository';

const url = '/countries';

export default {
    /**
     * Returns a complete list of countries with id and name
     *
     * @returns {Promise<AxiosResponse<any>>}
     */
    getSimple() {
        return Repository.get(`${url}/simple`);
    },

    /**
     *
     * Returns a simple list of countrieds with id and the calling_code
     *
     * @returns {Promise<AxiosResponse<any>>}
     */
    getSimplePhonePrefix() {
        return Repository.get(`${url}/simple-calling-codes`);
    }
}
